import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="M8.12 2.742a2 2 0 0 1 2.76 0L16 7.619l5.12-4.877a2 2 0 0 1 2.76 0l5.5 5.238A2 2 0 0 1 30 9.428v18.381a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.428a2 2 0 0 1 .62-1.448l5.5-5.238Zm-.101 9.442c0-.207.168-.375.375-.375h2.25c.207 0 .375.168.375.375v2.25a.375.375 0 0 1-.375.375h-2.25a.375.375 0 0 1-.375-.375v-2.25Zm0 7.625a1 1 0 0 0-1 1v7h5v-7a1 1 0 0 0-1-1h-3Zm12 1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v7h-5v-7Zm1.375-9a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375h-2.25Z" clip-rule="evenodd" stroke="none"></path>';
export var TownhouseSVG = function TownhouseSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TownhouseSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TownhouseSVG);